import {
  FluentProvider,
  FluentProviderProps,
  makeStyles,
  PartialTheme,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

export interface FluentProviderCustomProps {
  rcName?: string;
  theme?: string;
}

const useStyles = makeStyles({
  root: {
    "& .btn-delete-icon svg": {
      color: "var(--colorPaletteRedForeground1)",
    },
  },
});

const FluentProviderCustom = (
  props: FluentProviderProps & FluentProviderCustomProps,
) => {
  const styles = useStyles();
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  return (
    <FluentProvider
      {...props}
      className={styles.root}
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
              ...renderTheme,
              colorCompoundBrandStroke: "rgb(70, 101, 136)",
              colorCompoundBrandStrokeHover: "rgb(21, 51, 89)",
              colorCompoundBrandForeground1: "rgb(70, 101, 136)",
              colorCompoundBrandForeground1Hover: "rgb(21, 51, 89)",
              colorNeutralForeground2BrandHover: "rgb(21, 51, 89)",
              colorCompoundBrandBackground: "rgb(70, 101, 136)",
              colorCompoundBrandBackgroundHover: "rgb(21, 51, 89)",
              colorBrandBackground: "rgb(70, 101, 136)",
              colorBrandBackgroundHover: "rgb(21, 51, 89)",
              colorNeutralForeground2BrandSelected: "rgb(70, 101, 136)",
            }
      }
    ></FluentProvider>
  );
};

export default FluentProviderCustom;
